import React from 'react';
import ReactDOM from 'react-dom';

import { createRoot } from 'react-dom/client';

import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { store } from './store';
import { setPage } from './actions';

import Main from './components/component.main';
import Page from './components/component.page';

//sass
import './../sass/main.scss';

const route = (props) => {
    setPage(store.dispatch, props.match.params);
    return <Main><Page /></Main>;
}


const container = document.getElementById('root');

const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<Provider store={store}><BrowserRouter>
    <Switch>
        <Route path="/:page/:sub/:sub2" component={route}></Route>
        <Route path="/:page/:sub" component={route}></Route>
        <Route path="/:page" component={route}></Route>
        <Route path="/" component={route} />
    </Switch>
</BrowserRouter></Provider>);

